// extracted by mini-css-extract-plugin
export var text = "_52-0";